import React from "react";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";

import Typography from "@material-ui/core/Typography";

import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import {
  addModuleRoomListAction,
  deleteModuleRoomAction,
  updateModuleRoomAction,
  deleteModuleResourceAction,
  updateModuleResourceAction,
  addModuleResourceAction
} from "../../../../store/actions";

import ConditionsPanel from "./ConditionsPanel";

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "#F2F2F2",
    border: "1px solid #CACCD1",
    marginBottom: -1,
    minHeight: 40,
    margin: 0,
    padding: 0,
    "& .MuiExpansionPanelSummary-content": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: 0,
      "&  p": {
        fontSize: 14,
        color: "#00334E",
        marginLeft: "10px",
        marginTop: "3px"
      },
      "& svg": {
        fill: "#00334E"
      }
    },
    "&$expanded": {
      minHeight: 40
    }
  },
  content: {
    "&$expanded": {}
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column"
  }
}))(MuiExpansionPanelDetails);

const TechnicalConditions = ({
  allModuleLessonTheme,
  allRoomTypesList,
  addModuleRoomList,
  deleteModuleRoom,
  allModuleRoomList,
  updateModuleRoom,
  allResourceTypeList,
  allModuleResourceList,
  addModuleResource,
  updateModuleResource,
  deleteModuleResource
}) => {
  const [expandedLesson, setExpandedLesson] = React.useState();
  const [lessons, setLessons] = React.useState();

  React.useEffect(() => {
    if (allModuleLessonTheme) {
      setLessons(allModuleLessonTheme);
    }
  }, [allModuleLessonTheme]);

  const handleChangeLessonPanel = panel => (event, newExpandedLesson) => {
    setExpandedLesson(newExpandedLesson ? panel : false);
  };

  return (
    <Grid container direction="column">
      <Box fontSize={14} mb={2}>
        Материально-технические условия реализации модуля
      </Box>
      {lessons &&
        lessons.map((lesson, idx) => {
          return (
            <ExpansionPanel
              key={idx}
              square
              expanded={expandedLesson === `panel${lesson.id}`}
              onChange={handleChangeLessonPanel(`panel${lesson.id}`)}
            >
              <ExpansionPanelSummary>
                <div style={{ display: "flex" }}>
                  {expandedLesson === `panel${lesson.id}` ? (
                    <ArrowDropDownIcon />
                  ) : (
                    <ArrowRightIcon />
                  )}
                  <Typography>{`${lesson.typeName} ${lesson.number}. ${lesson.name}`}</Typography>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <ConditionsPanel
                  allRoomTypesList={allRoomTypesList}
                  allModuleRoomList={allModuleRoomList}
                  lesson={lesson}
                  addModuleRoomList={addModuleRoomList}
                  updateModuleRoom={updateModuleRoom}
                  deleteModuleRoom={deleteModuleRoom}
                  allResourceTypeList={allResourceTypeList}
                  allModuleResourceList={allModuleResourceList}
                  addModuleResource={addModuleResource}
                  updateModuleResource={updateModuleResource}
                  deleteModuleResource={deleteModuleResource}
                />
              </ExpansionPanelDetails>
            </ExpansionPanel>
          );
        })}
    </Grid>
  );
};

const mapStateToProps = state => ({
  allModuleLessonTheme: state.modules.allModuleLessonTheme,
  allRoomTypesList: state.modules.allRoomTypesList,
  allModuleRoomList: state.modules.allModuleRoomList,
  allModuleResourceList: state.modules.allModuleResourceList,
  allResourceTypeList: state.modules.allResourceTypeList
});

const mapDispatchToProps = dispatch => ({
  addModuleRoomList: data => dispatch(addModuleRoomListAction(data)),
  updateModuleRoom: (idRoom, data) =>
    dispatch(updateModuleRoomAction(idRoom, data)),
  deleteModuleRoom: idRoom => dispatch(deleteModuleRoomAction(idRoom)),
  addModuleResource: data => dispatch(addModuleResourceAction(data)),
  updateModuleResource: (idResource, data) =>
    dispatch(updateModuleResourceAction(idResource, data)),
  deleteModuleResource: idResource =>
    dispatch(deleteModuleResourceAction(idResource))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TechnicalConditions);
